import axios from '../../../../shared/axios/axios';

import * as actionTypes from '../constants/actionTypes';

export const getTasks = (pageRequest) => {
  const url = `/tasks-pipelines/get-tasks`;

  return axios
    .post(url, pageRequest)
    .then((response) => (response ? response.data : null))
    .catch((err) => console.log(err));
};

const getTaskStatusesStart = () => {
  return {
    type: actionTypes.GET_TASK_STATUSES_START,
  };
};

const getTaskStatusesSuccess = (data) => {
  return {
    type: actionTypes.GET_TASK_STATUSES_SUCCESS,
    taskStatuses: data,
  };
};

const getTaskStatusesFail = (error) => {
  return {
    type: actionTypes.GET_TASK_STATUSES_FAIL,
    error: error,
  };
};

export const getTaskStatuses = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getTaskStatusesStart());
      const url = `/tasks-pipelines/get-task-statuses`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getTaskStatusesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTaskStatusesFail(err));
          reject(err);
        });
    });
  };
};

const changeTaskStatusStart = () => {
  return {
    type: actionTypes.CHANGE_TASK_STATUS_START,
  };
};

const changeTaskStatusSuccess = (data) => {
  return {
    type: actionTypes.CHANGE_TASK_STATUS_SUCCESS,
  };
};

const changeTaskStatusFail = (error) => {
  return {
    type: actionTypes.CHANGE_TASK_STATUS_FAIL,
    error: error,
  };
};

export const changeTaskStatus = (id, newStatus) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(changeTaskStatusStart());
      const url = `/tasks-pipelines/change-status?id=${id}&newStatus=${newStatus}`;

      axios
        .post(url)
        .then((response) => {
          dispatch(changeTaskStatusSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(changeTaskStatusFail(err));
          reject(err);
        });
    });
  };
};

const getTaskPipelinesControlConfigStart = () => {
  return {
    type: actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_START,
  };
};

const getTaskPipelinesControlConfigSuccess = (data) => {
  return {
    type: actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_SUCCESS,
    taskPipelinesControlConfig: data,
  };
};

const getTaskPipelinesControlConfigFail = (error) => {
  return {
    type: actionTypes.GET_TASK_PIPELINES_CONTROL_CONFIG_FAIL,
    error: error,
  };
};

export const getTaskPipelinesControlConfig = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getTaskPipelinesControlConfigStart());
      const url = `/tasks-pipelines/get-tasks-pipelines-control-configuration`;

      axios
        .get(url)
        .then((response) => {
          dispatch(getTaskPipelinesControlConfigSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getTaskPipelinesControlConfigFail(err));
          reject(err);
        });
    });
  };
};
